/**
 * Service status constants
 * These represent the different states a service can be in
 */
export const ServiceStatus = {
  PENDING: 1,
  ACTIVE: 2,
  INACTIVE: 3,
} as const;

export type ServiceStatusType = 1 | 2 | 3;
